<script>
  import TextInput from '../../../../components/inputs/text';
  import Switch from '../../../../components/inputs/switch';
  import CoordinatorInput from '../../../../components/inputs/coordinator';
  import CategoryInput from '../../../../components/inputs/category';
  import AnnualScheduleInput from '../../../../components/inputs/schedule';
  import Form from '../../../../components/inputs/form';

  export let value;
  export let review = false;
  export let readonly = false;
</script>

<div>
  <Form>
    <div class="form-group">
      <TextInput readonly="{readonly}" bind:value={value.name} label="Program Name"
      placeholder="Program Name" />
    </div>
    <div class="form-group">
      <CoordinatorInput readonly="{readonly}" bind:value={value.coordinator.id} label="Program Coordinator" />
    </div>

    <div class="form-group">
      <CategoryInput readonly="{readonly}" bind:value={value.category.id} label="Primary Category" />
    </div>
    <div class="form-group">
      <CategoryInput readonly="{readonly}" bind:value={value.secondaryCategory.id} label="Secondary Category" />
    </div>
    <div class="form-group">
      <Switch
            bind:value="{value.isOnGoing}"
            label="Program is an on going opportunity?"
            name="constraint-program-is-ongoing"
          ></Switch>
    </div>
    <div class="form-group">
      <AnnualScheduleInput readonly="{readonly}" bind:value={value.annualSchedule} label="Annual Schedule" />
    </div>
  </Form>
</div>
